<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('feature.$consents.role_enabled_consents', {role: $t(`feature.roles.$type.${role_hcp}`)}) }}</h5>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <SpinnerLoading v-if="loading" class="mt-50" />
            <div class="table-responsive" v-else>
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.title.label') }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.description.label') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody> <!-- class="linked" -->
                        <tr v-for="consent in consents" :key="consent.id">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ consent.title }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                        {{ consent.description }}
                                    </div>
                                    <div>
                                        <SpinnerLoading class="h-auto" style="width: 30px;"
                                            v-if="loading_consent_id === consent.id" :small="true" />
                                        <div class="form-check form-group form-switch m-0" v-else>
                                            <input class="form-check-input shadow-none" type="checkbox" role="switch"
                                                v-model="consent.linked" :id="`${consent.id}-link`"
                                                @change="($event) => updateConsent(consent, $event)">
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <AlertModal id="alertModal_zone" :title="$t('feature.roles.remind_policies.title')"
        :message="$t('feature.roles.remind_policies.message',  {type: $t(`feature.roles.$type.${role_hcp}`)})" @close="alertModal?.hide()" />

</template>
<script lang="ts">
import { defineComponent, toRaw } from "vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { Consent } from "@/utils/models/consent.model";
import API from "@/services/api/api.service";
import { Role } from "@/utils/models/user.model";
import { AxiosResponse } from "axios";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import { Modal } from "bootstrap";

interface ConsentWithRoleLink extends Consent {
    linked?: boolean
};

type RoleOperation = (params: { consent_id: string | number, role_id: string | number }) => Promise<AxiosResponse<any, any>>;

export default defineComponent({
    name: 'ZoneConsents',
    components: {
        SpinnerLoading,
        AlertModal
    },
    props: {
        hcp_consent_id: {
            type: Array,
            required: true
        },
    },
    emits: ['update:hcp_consent_id'],
    data: function () {
        return {
            consents: [] as ConsentWithRoleLink[],
            linked_roles: [] as number[],
            loading_consent_id: undefined as number | string | undefined,
            alertModal: undefined as Modal | undefined,
            no_consents: false as boolean,
            loading: false as boolean,
        }
    },
    async mounted() {
        this.alertModal = new Modal('#alertModal_zone', {});
        await this.loadConsents();
    },
    computed: {
        selected_ids(): number[] {
            return (this.consents ?? []).filter((consent) => consent.linked ?? false)?.map((consent) => consent.id! as number);
        },
        role_hcp(): Role {
            return Role.hcp;
        },
    },
    methods: {
        loadConsents: async function () {
            this.loading = true;
            this.consents = [];
            await API.getConsents().then((response) => {
                this.consents = response.data?.data ?? [];
                this.consents.forEach((consent) => {
                    consent.linked = this.hcp_consent_id?.includes(consent.id!) ?? false;
                })
            }).finally(() => {
                this.loading = false;
            });
            
            this.no_consents = this.consents?.every((consent) => consent.linked === false);

            if (this.no_consents) {
                this.alertModal?.show();
            }

        },
        updateConsent(consent: ConsentWithRoleLink, $event: Event) {
            this.$emit('update:hcp_consent_id', this.selected_ids);
        }
    }
});
</script>